'use client';

import { theme } from 'components/theme';
import styles from './investor-relations.module.css';

export default function InvestorRelations() {
  return (
    <main
      style={{
        backgroundColor: theme.colors.background,
        color: theme.colors.primary,
      }}
    >
      <div className={`${styles.container} u-grid`}>
        <div style={{ padding: '6%' }}>
          <p>
            <strong style={{ fontWeight: 'bold' }}>MGT 7A</strong>
          </p>
          <p>
            <span className={styles.slim}>Please{` `}</span>
            <a href="https://s3.ap-south-1.amazonaws.com/ultrahuman.com/Form_MGT_7A+-+Ultrahuman+2022.pdf">
              <span className={styles.slim}>Click Here</span>
            </a>
            <span className={styles.slim}>
              {` `} to view and download the MGT 7A document.
            </span>
          </p>
        </div>
      </div>
    </main>
  );
}
